import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import type { ICockpitMdfSales } from '../../model/types'
import { OVERALL_CATEGORY } from '../revenueAndSob/constants'

import { OVERALL_OFFERING } from './getCockpitInitiativesInScope'

const USD_SALES_FIELD = {
  [ActualsValueTypes.Ndp]: 'ActualsCY',
  [ActualsValueTypes.Net]: 'ActualsCYNet',
  [ActualsValueTypes.TNet]: 'ActualsCYTNet',
  [ActualsValueTypes.UTNet]: 'ActualsCYUTNet',
} as const

interface IParams {
  rows: ICockpitMdfSales[]
  partnerIds: string[]
  fYear: number
  offering: string
  category: string | null
  metric: ActualsValueTypes
}

/** MDFSales contains annual amounts; no quarter split is returned by the backend. */
export const getCockpitMdfSalesFromData = ({
  rows,
  partnerIds,
  fYear,
  offering,
  category,
  metric,
}: IParams): number | null => {
  if (metric === ActualsValueTypes.None) return null

  const field = USD_SALES_FIELD[metric]
  const partners = new Set(partnerIds)
  const tokens = new Set<string>()
  let sales: number | null = null

  rows.forEach((row) => {
    if (
      !partners.has(row.PartnerId) ||
      row.FYear !== fYear ||
      (offering !== OVERALL_OFFERING && row.ProgramType !== offering) ||
      (category && category !== OVERALL_CATEGORY && row.BusinessUnit !== category)
    ) {
      return
    }

    const value = row[field]
    if (typeof value !== 'number' || !Number.isFinite(value)) return

    // EntryId identifies an initiative, not a sale: shared product tokens must count once.
    const tokenKey = JSON.stringify([
      row.PartnerId,
      row.FYear,
      row.ProgramType,
      row.BusinessUnit,
      row.TokenType,
      row.Token,
    ])
    if (tokens.has(tokenKey)) return

    tokens.add(tokenKey)
    sales = (sales ?? 0) + value
  })

  return sales
}
